const rowMenu = 'rowMenu';
const rowNumber = 'rowNumber';

export default { rowMenu, rowNumber };
